import type { Affiliation } from '~/types/services/agentHub';

export function formatAffiliationOptionLabel(option: Affiliation): string {
  const managedLabel = option.isManageable ? '[Managed]' : '[Unmanaged]';
  return `${option.region} - ${option.name} ${managedLabel}`;
}
